module.exports = __webpack_public_path__ + "static/img/bottom2.f549d1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bottom2.png
// module id = pKXM
// module chunks = 25